import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { formatDate } from '@/utility/utility';

interface TaskDetailTimestampsProps {
  startedAt?: string | null;
  submittedAt?: string | null;
  completedAt?: string | null;
  approvedAt?: string | null;
}

function TimestampRow({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
        {label}
      </p>
      <div className="text-sm text-gray-700">{value}</div>
    </div>
  );
}

export function TaskDetailTimestamps({
  startedAt,
  submittedAt,
  completedAt,
  approvedAt,
}: TaskDetailTimestampsProps) {
  const { t, i18n } = useTranslation(TranslationNS.LibsCommon);
  const hasTimestamps = startedAt || submittedAt || completedAt || approvedAt;
  if (!hasTimestamps) return null;

  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-3 rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
      {startedAt && (
        <TimestampRow
          label={t('dialog.startedAt')}
          value={formatDate(startedAt, {
            format: 'mediumTime',
            locale: i18n.language,
          })}
        />
      )}
      {submittedAt && (
        <TimestampRow
          label={t('dialog.submittedAt')}
          value={formatDate(submittedAt, {
            format: 'mediumTime',
            locale: i18n.language,
          })}
        />
      )}
      {completedAt && (
        <TimestampRow
          label={t('dialog.completedAt')}
          value={formatDate(completedAt, {
            format: 'mediumTime',
            locale: i18n.language,
          })}
        />
      )}
      {approvedAt && (
        <TimestampRow
          label={t('dialog.approvedAt')}
          value={formatDate(approvedAt, {
            format: 'mediumTime',
            locale: i18n.language,
          })}
        />
      )}
    </div>
  );
}
